import { useMemo } from 'react';

import { ConsumptionResponse, PeakResponse } from '@eneco/dc-be/client';
import { StringParam, withDefault, useQueryParam } from 'use-query-params';


import { isConsumptionResponse } from '../utils/typeGuards';

type Response = ConsumptionResponse | PeakResponse | null;

export const getSelectedPeriod = (response?: Response) => {
  if (response?.periods && response.periods.length > 0) {
    const periodsWithData = isConsumptionResponse(response)
      ? response.periods.filter(period => period.data && period.data.length > 0)
      : response.periods.filter(period => period.value);

    const sortedPeriods = [...periodsWithData].sort((a, b) => {
      const dateA = 'startDate' in a && a.startDate ? a.startDate : 'date' in a && a.date ? a.date : '';
      const dateB = 'startDate' in b && b.startDate ? b.startDate : 'date' in b && b.date ? b.date : '';
      return new Date(dateB).getTime() - new Date(dateA).getTime();
    });

    const lastPeriod = sortedPeriods[0];
    if (!lastPeriod) return null;
    const lastDate =
      'startDate' in lastPeriod && lastPeriod.startDate
        ? lastPeriod.startDate
        : 'date' in lastPeriod && lastPeriod.date
          ? lastPeriod.date
          : null;

    if (lastDate) {
      return lastDate;
    }
  }

  return null;
};

export const useSelectedPeriod = (consumptionData?: Response) => {
  const defaultSelected = useMemo(() => {
    return getSelectedPeriod(consumptionData);
  }, [consumptionData]);

  const SelectedParam = withDefault(StringParam, defaultSelected);
  const [selected, setSelected] = useQueryParam('selected', SelectedParam, {
    updateType: 'replaceIn',
  });

  return { selected, setSelected };
};
